// @flow

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Icon, Page } from "tabler-react";
import Ticker from "react-ticker";
import { TickerBox } from "../";
import $ from "jquery";

import "./style.css";
import "./ticker.css";
import "./mediaQueries.css";
import LightboxText from "../LightboxText";
import { helper } from "../../utils/helpers/helper";

let lastIndex = 0;

function Newsticker(props) {
  const lightbox = React.useRef();
  // Get ticker data from ticker reducer
  const { tickerData } = props;
  // This variable will create li indices for our news display
  const data =
    tickerData &&
    tickerData.map((data, i) => {
      return (
        <button
          className="btn-link btn"
          onClick={() => handleTickerNewsOpen(data)}
        >
          <span className="bn-seperator">
            {" "}
            <Icon prefix="fa" name="info-circle" className="red" />
          </span>
          {data.ticker_heading}
        </button>
      );
    });

    // Move is used to pause/play feature
const [move, handleMove] = useState(true);
const [popupOpen, handlePopupOpen] = useState(false);
// Clicked is used to check click event on news
// const [click, handleClicked] = useState(false);
//Pause/Play feature icon name

// const handlePopupOpenValChange = () => {
//   handleMove(false);
//   handleIconChange("play-circle");
//   handlePopupOpen(true);
// }

const [icon, handleIconChange] = useState("pause-circle");

  function handleTickerNewsOpen(tickerDetail) {
    handlePopupOpen(true);
    
    let url = "";
    if (!helper.isEmpty(tickerDetail.url)) {
      url = (
        <a href={tickerDetail.url} target="_blank" rel="noopener noreferrer">
          See More
        </a>
      );
    }
    
    const newsDetail = (
      <div className="newsDetail">
        <h5 className="quotes">{tickerDetail.ticker_heading}</h5>
        <div className="d-flex align-items-center px-2 newsWrapper">
          {/* <div className="left">
            <img src={tickerDetail?.image !== null ?  tickerDetail.image : TickerPlaceholder} alt={tickerDetail.ticker_heading} className="rounded"/>
          </div> */}
          <div className="right">
            <div>{tickerDetail.synopsis}</div>
            {url}
          </div>
        </div>
      </div>
    );
    lightbox.current.openPopupbox(newsDetail);
  }
  
  //This field will ensure our current & last news index
  // let [lastIndex, setLastIndex] = useState(0);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // action on update of news, this action will ensure alternate displays of news once all news completed
    lastIndex = data !== undefined ? data.length : 0;
    if (currentIndex + 1 > lastIndex) {
      setCurrentIndex(0);
    }
    $(function () {

      
      $(".btn-link").hover(function () {
        // if (click === true) {
        // handleClicked(false);
        // }
        handleMove(false);
        handleIconChange("play-circle");
      }, function(e){
        if(!$(this).hasClass("ticker-t-btn")){
          handleMove(true);
          handleIconChange("pause-circle");
        }
      });

      // $(".btn-link").on("mouseleave", function () {
        // if (click === true) {
        //   handleMove(false);
        //   handleIconChange("play-circle");
        // } else {
          // console.log(popupOpen);
        // if(popupOpen != true){
          // handleMove(true);
          // handleIconChange("pause-circle");
        // }
        // }
      // });
      $(".btn-link").on("click", function () {
        $(this).addClass("ticker-t-btn");
        
        // handleClicked(true);
        // handleMove(false);
        // handleIconChange("play-circle");
        // handlePopupOpen(true);
      });

      $("body").click(function(){
        if(popupOpen === true){
          $("button").removeClass("ticker-t-btn");
          handleMove(true);
          handleIconChange("pause-circle");
        }
      });

    });
  }, [currentIndex, data, move]);

  // useEffect(() => {}, []);
  //This function will change pause/play btn
  const toggleButton = () => {
    handleMove(!move);
    const iconName = !move === true ? "pause-circle" : "play-circle";
    handleIconChange(iconName);
  };

  //Ticker News Caller
  function apiCall() {
    lastIndex = data.length;
    if (currentIndex + 1 === lastIndex) {
      setCurrentIndex(0);
    }
    const index = setCurrentIndex(currentIndex + 1);
    return new Promise((resolve) => {
      window.setTimeout(() => {
        resolve(index);
      }, 500);
    });
  }

  const getNewsFromApi = async (index) => {
    const news = await apiCall();
    return news;
  };

  const RecieveNewsObject = () => {
    const [news, setNews] = useState(data[currentIndex]);
    useEffect(() => {
      getNewsFromApi().then((image) => {
        setNews(news);
      });
    }, [news]);
    if (news === undefined) {
      return <li></li>;
    } else {
      return news;
    }
  };

  //check if reloaded once already
  if (Array.isArray(tickerData) && tickerData.length > 0) {
    return (
      <>
        <TickerBox data-tut="ticker-control">
          <Page.Header>
            <div
              className="bn-breaking-news bn-effect-scroll bn-direction-ltr"
              id="newsTicker4"
            >
              <div className="bn-label">
                <button className="btn btn-primary" onClick={toggleButton}>
                  <Icon prefix="fe" name={icon} />
                </button>
              </div>
              <div className="bn-news">
                <ul>
                  <Ticker
                    offset="run-in"
                    speed={8}
                    move={move}
                    direction="toLeft"
                    mode="chain"
                  >
                    {(index) => (
                      <li>
                        <RecieveNewsObject />
                      </li>
                    )}
                  </Ticker>
                </ul>
              </div>
            </div>
          </Page.Header>
        </TickerBox>
        <LightboxText ref={lightbox} />
      </>
    );
  } else {
    return (
      <TickerBox data-tut="ticker-control">
        <Page.Header>
          <div
            className="bn-breaking-news bn-effect-scroll bn-direction-ltr"
            id="newsTicker4"
          >
            <div className="bn-label">
              <button className="btn btn-primary" onClick={toggleButton}>
                <Icon prefix="fe" name={icon} />
              </button>
            </div>
            <div className="bn-news">
              <ul>
                <Ticker
                  offset="run-in"
                  speed={8}
                  move={move}
                  direction="toLeft"
                  mode="chain"
                >
                  {(index) => <button className="btn-link btn"></button>}
                </Ticker>
              </ul>
            </div>
          </div>
        </Page.Header>
      </TickerBox>
    );
  }
}
function mapStateToProps(state) {
  const { tickerData } = state.ticker;
  return {
    tickerData,
  };
}

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Newsticker);
